
import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {ValidationErrors} from '@returns-centre/components';
import {getModule} from 'vuex-module-decorators';
import {CustomerModule, ShopModule, store, TradeInModule} from "@returns-centre/store";
import AppAccordion from "@returns-centre/components/AppAccordion.vue";
import AppLookupButton from "@returns-centre/components/AppLookupButton.vue";
import AppHeader from "@returns-centre/components/AppHeader.vue";
import {VueModal} from "@/components";
import router from "@returns-centre/routes/index";
import {alertService} from "@returns-centre/services";

@Component({
    components: {
        AppHeader,
        AppAccordion,
        ValidationErrors,
        AppLookupButton,
        VueModal
    }
})
export default class VerifyOrder extends Vue {
    shopModule = getModule(ShopModule, store);
    customerModule = getModule(CustomerModule, store);
    shop = this.shopModule.getShop;
    tradeInModule = getModule(TradeInModule, store);
    infoModal = false;
    form: OrderToVerify = {
        order_name: '',
        identifier: ''
    }

    login() {
        if (!this.shopModule.shop) {
            return;
        }
        if(this.shopModule.shop.shop_domain === "wyzecom.myshopify.com"
        || this.shopModule.shop.shop_domain === "wyze-playground.myshopify.com"){
            window.location.href = 'https://www.wyze.com/account/login?checkout_url=https%3A%2F%2Fwww.wyze.com%2Fapps%2Ftrade-in';
            return;
        }

        window.location.href = 'https://'
            + this.shopModule.shop.shop_domain
            + '/account/login'
            + '?checkout_url=/apps/trade-in';
    }

    startProductRegistration() {
        router.push({name: 'TradeInRegister'});
    }

    closeInfoModal() {
        this.infoModal = false;
    }

    openInfoModal() {
        this.infoModal = true;
    }
}
